
export function htmlDecode (text) {
  if (undefined == text || null == text) {
    return "";
  }
  if (text.indexOf("&lt;") >= 0 
    && text.indexOf("&gt;") >= 0 
    && (
    text.indexOf("&lt;div") >= 0 
    || text.indexOf("&lt;p") >= 0 
    || text.indexOf("&lt;h") >= 0 
    || text.indexOf("&lt;span") >= 0 
    || text.indexOf("&lt;a") >= 0
    )) {
    var temp = document.createElement("div");
    temp.innerHTML = text;
    var output = temp.innerText || temp.textContent;
    temp = null;
    return output;
  } else {
    return text;
  }    
};

export function htmlPlain(text) {
  if (undefined == text || null == text) {
    return "";
  }
  if (text.indexOf("&lt;") >= 0 
    && text.indexOf("&gt;") >= 0 
    && (
    text.indexOf("&lt;div") >= 0 
    || text.indexOf("&lt;p") >= 0 
    || text.indexOf("&lt;h") >= 0 
    || text.indexOf("&lt;span") >= 0 
    || text.indexOf("&lt;a") >= 0
    )) {
    var temp = document.createElement("div");
    temp.innerHTML = text;
    text = temp.innerText || temp.textContent;
    temp = null;
  }
  if (text.indexOf("<") >= 0 
    && text.indexOf(">") >= 0 
    && (
    text.indexOf("<div") >= 0 
    || text.indexOf("<p") >= 0 
    || text.indexOf("<h") >= 0 
    || text.indexOf("<span") >= 0 
    || text.indexOf("<a") >= 0
    )) {
    var temp = document.createElement("div");
    temp.innerHTML = text;
    text = temp.innerText || temp.textContent;
    temp = null;
  }
  return text;
}


// WEBPACK FOOTER //
// ./src/utils/html.js